import * as ACTION from '../actions/modal';
import { Action } from '../types/types';

export const MODAL_TEMPLATES = {
	DESTINATION_FAILED: 'destination-failed',
	BROADCAST_FAILED: 'broadcast-failed',
	RECORDING_FAILED: 'recording-failed',
	DEVICE_PERMISSION: 'device-permission',
	EMPTY: '',
	MEDIA_LIBRARY: 'media-library',
	EVENT_SETTINGS: 'event-settings',
	STREAM_DESTINATION_SETTINGS: 'stream-destination-settings',
	AVATAR_PHOTO: 'avatar-photo',
	SAFETY_PHOTO: 'safety-photo',
	SHOT_BUILDER: 'shot-builder',
	DELETE_SHOT_CONFIRMATION: 'delete-shot-confirmation',
	DELETE_SEGMENT_CONFIRMATION: 'delete-segment-confirmation',
	COPY_EVENT: 'copy-event',
	DELETE_EVENT_CONFIRMATION: 'delete-event-confirmation',
	PROGRAM_FEED: 'program-feed',
	ONSITE_FEED: 'onsite-feed',
	ONSITE_LOCATION: 'onsite-location',
	VIDEO_EDITOR: 'video-editor',
	DELETE_ACCOUNT: 'delete-account',
	MULTI_ACCOUNT_LOGGED_IN: 'multi-account-logged-in',
	LIVE_STREAM_CONFIRMATION: 'live-stream-confirmation',
	DELETE_CHAT_MESSAGE_CONFIRMATION: 'delete-chat-message-confirmation',
	DELETE_CHAT_ROOM_CONFIRMATION: 'delete-chat-room-confirmation',
	NO_ROOM_ACCESS: 'no-room-access',
	DELETE_MASK_CONFIRMATION: 'delete-mask-confirmation',
	PRODUCT_TOUR: 'product-tour',
	MULTI_ONSITE_LOCATION: 'multi-onsite-location',
	DELETE_THEME: 'delete-theme-confirmation',
	GR_PICTURE: 'gr-picture',
	GENERATED_CONTENT_UPDATING: 'generated-content-updating',
};

export const MODAL_INFO_ACTIONS = {
	ADD: 'add',
	EDIT: 'edit',
	DELETE: 'delete',
	INVITE: 'invite',
};

export const MODAL_AVATAR_ACTIONS = {
	AVATAR: 'avatar',
	CHANNEL_ICON: 'channel-icon',
	VIRTUAL_BACKGROUND: 'virtual-background',
	HOLD_SLIDE: 'hold-slide',
};

export const MODAL_SAFETY_PHOTO_ACTIONS = {
	SAFETY_PHOTO: 'safety-photo',
	SAFETY_PHOTO_SRT: 'safety-photo-srt',
	SAFETY_PHOTO_ONSITE_LOCATION: 'safety-photo-onsite-location',
};

export const initialModalState: ModalState = {
	modalOpen: false,
	modalTemplate: '',
	modalData: {},
};

export interface ModalState {
	modalOpen: boolean;
	modalTemplate: string;
	modalData: any;
}

const initialState: ModalState = {
	modalOpen: false,
	modalTemplate: MODAL_TEMPLATES.EMPTY,
	modalData: {},
};

const actions: Map<string, Function> = new Map([
	[ACTION.SET_MODAL_OPEN, (state: ModalState, action: Action) => (
		{ ...state, modalOpen: action.payload }
	)],
	[ACTION.SET_MODAL_TEMPLATE, (state: ModalState, action: Action) => (
		{ ...state, modalTemplate: action.payload }
	)],
	[ACTION.SET_MODAL_DATA, (state: ModalState, action: Action) => (
		{ ...state, modalData: action.payload }
	)],
	[ACTION.SET_MODAL_STATE, (state: ModalState, action: Action) => (
		{ ...state, ...action.payload }
	)],
	[ACTION.SET_MODAL_CLOSED, () => (
		{ ...initialState }
	)],
]);

// eslint-disable-next-line default-param-last
export function ModalReducer(state: ModalState = initialState, action: Action) {
	return actions.get(action.type)?.(state, action) || state;
}
